/**
 * Human-readable "今天 · 小雨" style label. Deterministic weather from the
 * date so SSR/CSR stay in sync (no Math.random on first paint).
 */
const WEATHERS = ["小雨", "微风", "多云", "晴", "夜灯", "薄雾"];

export function todayLabel(locale: string): string {
  const d = new Date();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const weather = WEATHERS[(month + day) % WEATHERS.length];
  if (locale.startsWith("en")) {
    const opts: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
    const en = ["light rain", "breeze", "cloudy", "clear", "night lamp", "mist"];
    return `${new Intl.DateTimeFormat("en-US", opts).format(d)} · ${en[(month + day) % en.length]}`;
  }
  return `${month}月${day}日 · ${weather}`;
}

export function timeAgoLabel(iso: string, locale: string): string {
  const then = new Date(iso).getTime();
  const mins = Math.max(1, Math.round((Date.now() - then) / 60000));
  if (mins < 60)
    return locale.startsWith("en") ? `${mins}m ago` : `${mins}分钟前`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return locale.startsWith("en") ? `${hrs}h ago` : `${hrs}小时前`;
  const days = Math.round(hrs / 24);
  return locale.startsWith("en") ? `${days}d ago` : `${days}天前`;
}

/** Compact system date label for timeline nodes, e.g. "8月29日" / "Aug 29". */
export function entryDateLabel(iso: string, locale: string): string {
  const d = new Date(iso);
  if (locale.startsWith("en")) {
    return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" }).format(d);
  }
  return `${d.getMonth() + 1}月${d.getDate()}日`;
}
